<template>
  <HeaderView active="1-1" />

  <div id="main-content">

    <div class="et_pb_section title_section">
      <div class="et_pb_row">
        <div class="et_pb_column col-large2" style="width: 100%;">
          <div class="et_pb_module mb0">
            <h1>方位伽马传感器（Azimuthal Gamma Detector）</h1>
          </div>
        </div>

      </div>
    </div>

    <div class="et_pb_section main_section a_text pv30">
      <div class="et_pb_row">
        <div class="et_pb_column">
            <img loading="lazy" decoding="async"
              :src="img_p02_1"
              class="wp-image-a et-animated"/>
        </div>
      </div>

      <div class="et_pb_row">
        <div class="et_pb_column">
            <img loading="lazy" decoding="async"
              :src="img_p02_3"
              class="wp-image-a et-animated"/>
        </div>
      </div>

    </div>
  </div>

  <FooterView />
</template>

<script>
import HeaderView from "../components/Header.vue";
import FooterView from "../components/Footer.vue";
import img_p02_1 from '@/assets/images/p02_1.png';
import img_p02_3 from '@/assets/images/p02_3.png';

export default {
  components: {
    HeaderView,
    FooterView
  },

  data: () => ({
    img_p02_1,
    img_p02_3,
  }),

}
</script>

<style scoped></style>
